import React from 'react';
const BulbIcon = () => (
    <svg width="27" height="32" viewBox="0 0 75 88" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M59.5 42.9972C59.5 57.2132 51.8888 57.2155 49.671 64.0226C47.4532 70.8297 50.6241 76 45.1066 76L30.4696 75.9251C24.774 75.9251 27.5094 70.7337 25.2845 64.0226C23.0597 57.3115 15.5 57.8524 15.5 42.9972C15.5 30.8489 25.3501 21 37.5 21C49.6499 21 59.5 30.8489 59.5 42.9972Z"
            fill="white"
            stroke="black"
            strokeWidth="2"
            strokeMiterlimit="10"
        />
        <path
            d="M34.5 76L31 50L37 53.5L43 50L40.5 76"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M30 76H45V81C45 84.3137 42.3137 87 39 87H36C32.6863 87 30 84.3137 30 81V76Z"
            fill="white"
            stroke="black"
            strokeWidth="2"
        />
        <rect x="36.5" width="2" height="16" rx="1" fill="#32AE57" />
        <rect
            x="74.5"
            y="43"
            width="2"
            height="10"
            rx="1"
            transform="rotate(90 74.5 43)"
            fill="#32AE57"
        />
        <rect
            x="74.5"
            y="43"
            width="2"
            height="10"
            rx="1"
            transform="rotate(90 74.5 43)"
            fill="#32AE57"
        />
        <rect
            width="2"
            height="10"
            rx="1"
            transform="matrix(4.37114e-08 1 1 -4.37114e-08 0.5 43)"
            fill="#32AE57"
        />
        <rect
            x="67.6924"
            y="16"
            width="2"
            height="13"
            rx="1"
            transform="rotate(45 67.6924 16)"
            fill="#32AE57"
        />
        <rect
            width="2"
            height="13"
            rx="1"
            transform="matrix(-0.707107 0.707107 0.707107 0.707107 7.91422 16)"
            fill="#32AE57"
        />
    </svg>
);

export default BulbIcon;
